import { enUS, es } from "date-fns/locale"
import { SupportedLanguage } from "../types/language"


export function currentLanguageLocale(currentLanguage: SupportedLanguage): Locale {
  if(currentLanguage === 'es') return es

  return enUS
}